import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchCustomer, fetchCustomerTypes, fetchThirdParties } from '@sophocles/api/customer';

export const loadCustomerTypes = createAsyncThunk('customer/types/load', async (queryParams, { rejectWithValue }) => {
  try {
    const data = await fetchCustomerTypes(queryParams);
    return data;
  } catch (e) {
    return rejectWithValue(e.response.data);
  }
});

export const loadCustomer = createAsyncThunk('customer/load', async (customerId, { rejectWithValue }) => {
  try {
    const data = await fetchCustomer(customerId);
    return data;
  } catch (e) {
    return rejectWithValue(e.response.data);
  }
});

export const loadThirdParties = createAsyncThunk(
  'customer/thirdParties/loadMany',
  async ({ customerId, queryParams }, { rejectWithValue }) => {
    try {
      const data = await fetchThirdParties(customerId, queryParams);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);
